import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { InviteHostsService } from '@app/shared/services/invite-hosts/invite-hosts.service';

@Component({
  standalone: false,
  templateUrl: './host-invite.component.html',
  styleUrls: ['./host-invite.component.scss'],
})
export class HostInviteComponent implements OnInit {
  loading: boolean = false;
  error: boolean = false;
  token: string = '';

  inviteDetails: {
    inviter: {
      name: string;
      picture: string;
    };
    invitee: {
      name: string;
    };
    oauth_link: string;
    permissions: 'reservations' | 'calendar'[];
  };

  constructor(
    private route: ActivatedRoute,
    private readonly inviteHostService: InviteHostsService
  ) {}

  ngOnInit(): void {
    this.loading = true;
    this.route.params.subscribe((params) => {
      this.token = params['token'];
      this.getInviteDetails(this.token);
    });
  }

  getInviteDetails(token: string) {
    // todo - API call to fetch the invite details
    this.inviteHostService.fetchInviteDetails(token).subscribe(
      (res) => {
        this.loading = false;
        this.inviteDetails = res;
      },
      (error) => {
        this.loading = false;
        this.error = true;
      }
    );
  }

  connectAirbnb() {
    window.location.href = this.inviteDetails.oauth_link;
  }
}
